import { router } from 'ui-utilities';

export default function Form(handle, {
    actions,
    events,    
}) {
    const form = handle.querySelector('form');
    const errorsCont = handle.querySelector('.errors');
    const submit = handle.querySelector('[type="submit"]');

    if (!form) {
        return;
    }

    function clearErrors() {
        errorsCont.style.display = 'none';
        errorsCont.innerHTML = '';
    }

    function handleErrors(errors) {
        Object.keys(errors).forEach(field => {
            errorsCont.insertAdjacentHTML('beforeend', `<li>${errors[[field]]}</li>`)
            errorsCont.style.display = 'block';
        });
    }

    function handleSuccess() {
        form.querySelectorAll('.input').forEach(input => {
            input.style.display = 'none';
        });
        errorsCont.style.display = 'none';
        submit.style.display = 'none';
        form.querySelector('fieldset').insertAdjacentHTML('beforeEnd', '<p class="success">Thank you, we’ll be in touch!</p>')
    }

    function handleSubmit(e) {
        e.preventDefault();

        const url = '/';
        const formData = new FormData(form);

        function cb(res) {
            const { success, errors = [] } = JSON.parse(res);
            submit.removeAttribute('disabled');

            if (!success) {
                handleErrors(errors);
                return;
            }

            handleSuccess();
            return;
        }

        clearErrors();
        submit.setAttribute('disabled', true);
        router.post({ url, formData, cb });        
    }
    
    form.addEventListener('submit', handleSubmit);
}
